export const SUPERPLANE_PRICING_URL = "https://superplane.com/pricing/";
